module.exports = __webpack_public_path__ + "static/media/shapes_01.5e0c1582.svg";